<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="80px">
            <el-form-item label="姓名">
                <el-input
                    v-model="queryParams.userName"
                    placeholder="请输入姓名"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="手机号">
                <el-input
                    v-model="queryParams.phone"
                    placeholder="请输入手机号"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="类型">
                <el-input
                    v-model="queryParams.type"
                    placeholder="请输入类型"
                    clearable
                    @keyup.enter.native="handleQuery"
                />
            </el-form-item>
            <el-form-item label="日期">
                <el-date-picker
                    v-model="queryParams.date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <!--        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            </el-form-item>
        </el-form>

        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                    type="warning"
                    icon="el-icon-download"
                    size="mini"
                    @click="handleExport"
                >导出
                </el-button>
            </el-col>
            <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
        </el-row>
        <label class="el-form-item__label" style="padding-left: 15px">
            总收入：<label style="color: #ed5565">{{ zonge.sum }}</label> 元 ,
            房租总额：<label style="color: #ed5565">{{ zonge.sum3 }}</label> 元 ,
            物业费总额：<label style="color: #ed5565">{{ zonge.sum4 }}</label> 元 ,
            押金总额：<label style="color: #ed5565">{{ zonge.sum5 }}</label> 元 ,
            水费总额：<label style="color: #ed5565">{{ zonge.sum6 }}</label> 元 ,
            电费总额：<label style="color: #ed5565">{{ zonge.sum7 }}</label> 元
        </label>
        <el-table v-loading="loading" :data="mingxiList" @selection-change="handleSelectionChange">
            <!--        <el-table-column type="selection" width="55" align="center"/>-->
            <el-table-column label="姓名" align="center" prop="userName"/>
            <el-table-column label="手机号" align="center" prop="phone"/>
            <el-table-column label="类型" align="center" prop="type"/>
            <el-table-column label="金额" align="center" prop="money">
                <template slot-scope="scope">
                    <label style="color: #F56C6C" v-if="scope.row.zeJi ==2">- {{ scope.row.money }} 元</label>
                    <label style="color: #67C23A" v-if="scope.row.zeJi ==1">+ {{ scope.row.money }} 元</label>
                </template>
            </el-table-column>
            <el-table-column label="交易时间" align="center" prop="createTime"/>
        </el-table>
        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
    </div>
</template>

<script>
import {listMingxi, getMingxi, delMingxi, addMingxi, updateMingxi, count, mingxiExort} from "@/api/homestay/api";

export default {
    name: "Mingxi",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 金额明细表格数据
            mingxiList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                userName: null,
                openId: null,
                type: null,
                date: null,
            },
            zonge: {},
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                userName: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                openId: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                type: [
                    {required: true, message: "1房租 2续租 3水费 4电费 5押金 6物业费不能为空", trigger: "change"}
                ],
                money: [
                    {required: true, message: "金额不能为空", trigger: "blur"}
                ],
                delFlag: [
                    {required: true, message: "删除标志不能为空", trigger: "blur"}
                ],
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询金额明细列表 */
        getList() {
            this.loading = true;
            listMingxi(this.queryParams).then(response => {
                this.mingxiList = response.data;
                this.total = response.total;
                this.loading = false;
                count(this.queryParams).then(res => {
                    this.zonge = res.data
                })
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                userName: null,
                openId: null,
                type: null,
                money: null,
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.form.date = null
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加金额明细";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const id = row.id || this.ids.join(',')
            getMingxi(id).then(response => {
                this.form = response.data;
                this.open = true;
                this.title = "修改金额明细";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateMingxi(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addMingxi(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const ids = row.id || this.ids.join(',');
            this.$modal.confirm('是否确认删除金额明细编号为"' + ids + '"的数据项？').then(function () {
                return delMingxi(ids);
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {
            });
        },
        /** 导出按钮操作 */
        handleExport() {
            this.loading = true;
            mingxiExort(this.queryParams).then((res) => {
                this.$modal.msgSuccess(res.msg);
                this.loading = false;
                this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
            });
        }
    }
};
</script>
